export default function orderStopsByRoutePoints(stops = [], points = []) {
  if (!Array.isArray(stops) || !Array.isArray(points)) return stops

  const stopsById = new Map()
  const orderedStops = []
  const usedStops = new Set()

  stops.forEach(stop => {
    if (stop?.id != null && !stopsById.has(String(stop.id))) {
      stopsById.set(String(stop.id), stop)
    }
  })

  points.forEach(point => {
    const stopId = point?.stop?.id
    if (stopId == null) return

    const stop = stopsById.get(String(stopId))
    if (!stop || usedStops.has(stop)) return

    orderedStops.push(stop)
    usedStops.add(stop)
  })

  stops.forEach(stop => {
    if (!usedStops.has(stop)) orderedStops.push(stop)
  })

  return orderedStops
}
